import { Box, Text } from '@wix/design-system';
import { NavigationButton } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import { ChevronLeftSmall } from '@wix/wix-ui-icons-common';
import styles from './NavigateBack.scss';

type NavigateBackProps =
  | { onBack: () => void; backButtonText: string; verticalCenter?: boolean }
  | { onBack?: never; backButtonText?: never; verticalCenter?: never };

export const NavigateBack = ({
  onBack,
  backButtonText,
  verticalCenter,
}: NavigateBackProps) => {
  if (!onBack) {
    return null;
  }
  return (
    <Box
      position="relative"
      alignSelf={verticalCenter ? 'stretch' : undefined}
    >
      {onBack && (
        <NavigationButton
          onClick={onBack}
          direction="back"
          isVisible={true}
          alwaysShowText={true}
          icon={<ChevronLeftSmall />}
          top={verticalCenter ? '50%' : -20}
          left={0}
          style={verticalCenter ? { transform: 'translateY(-50%)' } : undefined}
          text={
            backButtonText ? (
              <Box className={styles.navigateBackText}>
                <Text size="small" weight="normal">
                  {backButtonText}
                </Text>
              </Box>
            ) : null
          }
        />
      )}
    </Box>
  );
};
